import React, { useCallback, useEffect, useState } from 'react'
import { Box, Container, Grid, IconButton, Tab, Tabs, Theme, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import FavoriteIcon from '@mui/icons-material/Favorite'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import clsx from 'clsx'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { parse } from 'query-string'
import { usePrevious } from 'react-use'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import { animateScroll as scroll } from 'react-scroll/modules'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { AccessTime as AccessTimeIcon } from '@mui/icons-material'
import { formLocale, Layout, Loader, TabPanel } from '../../components'
import { NewsVideoModal } from './news-video-modal'
import { img as imgs, img } from '../../imgs'
import { getMediaMarket, getQuizMediaCup, votedMediaMarket } from '../../api'
import { modalsAction } from '../../store/modals'
import { useReduxSelector } from '../../hooks'

const VoteItem: React.FC<{ item: any; indexPhoto?: number; listPhoto?: any; className: any }> = ({
  item = [],
  indexPhoto = 0,
  listPhoto = [],
  className,
}): JSX.Element => {
  const dispatch = useDispatch()

  const { serverError } = formLocale

  const { data: constants } = useReduxSelector((state) => state.constants)

  const [like, setLike] = useState<any>({
    voted: item.voted,
    num: item.vote,
  })

  const [newsVideoModal, setNewsVideoModal] = useState<boolean>(false)

  const onVoted = (id: number) => {
    votedMediaMarket({ id })
      .then((res) => {
        if (res.status === 1) {
          setLike({ voted: true, num: like.num + 1 })
        } else {
          dispatch(
            modalsAction.alert({
              message: res.message,
              onClose: () => {},
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          modalsAction.alert({
            message: serverError,
            onClose: () => {},
          })
        )
      })
  }

  return (
    <>
      <NewsVideoModal
        item={item}
        indexSlide={indexPhoto}
        listPhoto={listPhoto}
        show={newsVideoModal}
        onClose={() => setNewsVideoModal(false)}
        className={className}
      />

      {item.type === 'INTERVIEW' ? (
        <Box
          className={clsx(className.voteItemZoomInterview, { [className.voteItemZoomBg]: item.typeSrc === 'VIDEO' })}
          onClick={() => {
            if (item.body || item.typeSrc === 'VIDEO') setNewsVideoModal(true)
          }}
        >
          {item.src && (item.typeSrc === 'PHOTO' || item.type === 'REPORTS') ? (
            <img
              id="play-container"
              src={
                item.src
                  ? constants?.PROFILE === 'prod'
                    ? `https://cup.irb.rest${item.src}`
                    : `https://irbcup.xtest.atoms.ru${item.src}`
                  : ''
              }
              alt=""
              className={className.voteItemPhotoInterview}
            />
          ) : (
            <>
              <Box id="play-container" className={className.voteItemInterviewVideo} />
              <Box position="absolute" top={0} left={0} className={className.voteItemInterviewPlayBox}>
                <Box id="play-btn" className={className.voteItemInterviewPlay}>
                  <PlayArrowIcon />
                </Box>
              </Box>
            </>
          )}
        </Box>
      ) : (
        <Box
          className={clsx(className.voteItemZoom, { [className.voteItemZoomBg]: item.type === 'VIDEO' })}
          onClick={() => {
            if (item.type === 'VIDEO' || item.type === 'PHOTO' || item.type === 'REPORTS') setNewsVideoModal(true)
          }}
        >
          {item.type === 'VIDEO' && (
            <>
              <Box id="play-container" className={className.voteItemVideo} />
              <Box position="absolute" top={0} left={0} className={className.voteItemPlayBox}>
                <Box id="play-btn" className={className.voteItemPlay}>
                  <PlayArrowIcon />
                </Box>
              </Box>
            </>
          )}
          {(item.type === 'PHOTO' || item.type === 'REPORTS') && (
            <img
              id="play-container"
              src={
                item.src
                  ? constants?.PROFILE === 'prod'
                    ? `https://cup.irb.rest${item.src}`
                    : `https://irbcup.xtest.atoms.ru${item.src}`
                  : ''
              }
              alt=""
              className={className.voteItemPhoto}
            />
          )}
        </Box>
      )}
      <Grid container wrap="nowrap" justifyContent="flex-start" alignItems="center">
        <Grid item>
          <IconButton
            color="secondary"
            onClick={() => {
              if (!like.voted) onVoted(item.id)
            }}
          >
            {like.voted ? (
              <FavoriteIcon
                color="secondary"
                className={clsx(
                  { [className.like]: item.type !== 'INTERVIEW' },
                  { [className.likeInterview]: item.type === 'INTERVIEW' }
                )}
              />
            ) : (
              <FavoriteBorderIcon
                color="secondary"
                className={clsx(
                  { [className.like]: item.type !== 'INTERVIEW' },
                  { [className.likeInterview]: item.type === 'INTERVIEW' }
                )}
              />
            )}
          </IconButton>
        </Grid>
        <Grid item>
          <Box className={className.numLike}>{like.num}</Box>
        </Grid>
      </Grid>
      {item.type === 'INTERVIEW' ? (
        <>
          <Box className={className.voteItemTitle}>{item.name}</Box>
          <Box className={clsx(className.voteItemText, className.voteItemTextSmall)}>
            {item.anons ? item.anons : item.body}
          </Box>
          {item.body && (
            <Box className={className.voteItemFurther}>
              <Box className={className.link} onClick={() => setNewsVideoModal(true)}>
                Читать далее &gt;&gt;
              </Box>
            </Box>
          )}
        </>
      ) : (
        <Box className={className.voteItemText}>{item.name}</Box>
      )}
    </>
  )
}

export const MediaTopicManagerPage: React.FC = (): JSX.Element => {
  const classes = useStyles()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id: managerId } = useParams()

  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const { pathname, search, hash } = useLocation()
  const prevLocation = usePrevious({ location: { pathname, search, hash } })

  const { serverError } = formLocale

  const [loadQuiz, setLoadQuiz] = useState<boolean>(true)

  const [tab, setTab] = useState<number>(0)
  const [btnTop, setBtnTop] = useState<any>({
    video: 0,
    photo: 0,
    interview: 0,
    reports: 0,
  })

  const [mediaMarket, setMediaMarket] = useState<any>(undefined)
  const [photoMarket, setPhotoMarket] = useState<any[]>([])
  const [photoReportsMarket, setPhotoReportsMarket] = useState<any[]>([])

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const onScrollTop = () => {
    scroll.scrollToTop()
  }

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    // loadMediaMarketList()
    console.log(newValue)
    setTab(newValue)
  }

  const loadMediaQuiz = useCallback(() => {
    getQuizMediaCup()
      .then((res) => {
        const query = parse(search)
        if (res.data.quiz) navigate('../media')
      })
      .catch(() => {
        navigate('../media')
      })
  }, [])

  const loadMediaMarketList = useCallback(() => {
    getMediaMarket({ id: Number(managerId) })
      .then((res) => {
        if (res.status === 1) {
          setMediaMarket(res.data.media)
          setLoadQuiz(false)
        } else {
          dispatch(
            modalsAction.alert({
              message: res.message,
              onClose: () => {},
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          modalsAction.alert({
            message: serverError,
            onClose: () => {},
          })
        )
      })
  }, [])

  useEffect(() => {
    if (!prevLocation || prevLocation.location.search !== search) {
      const query = parse(search)

      switch (true) {
        case 'market' in query:
          break
        default:
          loadMediaQuiz()
          break
      }
    }
    window.scrollTo(0, 0)
    loadMediaMarketList()
  }, [])

  useEffect(() => {
    if (mediaMarket) {
      const listPhoto: any[] = []
      const listPhotoReports: any[] = []
      let video = 0
      let photo = 0
      let reports = 0
      let interview = 0

      mediaMarket.items.every((item: any, index: number) => {
        switch (item.type) {
          case 'REPORTS':
            listPhotoReports.push(item)
            reports++
            break
          case 'VIDEO':
            video++
            break
          case 'PHOTO':
            listPhoto.push(item)
            photo++
            break
          case 'INTERVIEW':
            interview++
            break
          default:
            break
        }
        return true
      })
      setPhotoMarket(listPhoto)
      setPhotoReportsMarket(listPhotoReports)
      setBtnTop({ video, photo, interview, reports })
    }
  }, [mediaMarket])

  return (
    <Layout>
      <Box className={classes.page}>
        {!loadQuiz && mediaMarket ? (
          <>
            <Container className={classes.container}>
              <Grid
                container
                wrap="nowrap"
                justifyContent={sm ? 'center' : 'flex-start'}
                alignItems="center"
                spacing={sm ? 0 : 2}
              >
                <Grid item xs={1} sm="auto">
                  <IconButton color="primary" className={classes.btnArrow} onClick={() => navigate('../media')}>
                    <ArrowBackIcon id="icon-arrow" />
                  </IconButton>
                </Grid>
                <Grid item>
                  <Box className={classes.title} onClick={() => navigate('../media')}>
                    Кубок в&nbsp;объективе
                  </Box>
                </Grid>
              </Grid>
              <Box className={classes.subTitle}>{mediaMarket.name}</Box>
              {mediaMarket.items.length > 0 ? (
                <>
                  <Grid container justifyContent={sm ? 'center' : 'flex-start'}>
                    <Grid item>
                      <Tabs value={tab} onChange={handleChangeTab}>
                        {btnTop.video > 0 && <Tab label="ВИДЕО" {...a11yProps(0)} />}
                        {btnTop.photo > 0 && <Tab label="ФОТО" {...a11yProps(btnTop.video > 0 ? 1 : 0)} />}
                        {btnTop.interview > 0 && (
                          <Tab
                            label="ИНТЕРВЬЮ"
                            {...a11yProps(
                              btnTop.video > 0 && btnTop.photo > 0
                                ? 2
                                : btnTop.video === 0 && btnTop.photo > 0
                                ? 1
                                : btnTop.video > 0 && btnTop.photo === 0
                                ? 1
                                : 0
                            )}
                          />
                        )}
                        {btnTop.reports > 0 && (
                          <Tab
                            label="РЕПОРТАЖ 3 ЭТАП"
                            {...a11yProps(
                              btnTop.video > 0 && btnTop.photo > 0 && btnTop.interview > 0
                                ? 3
                                : (btnTop.video === 0 && btnTop.photo > 0 && btnTop.interview > 0) ||
                                  (btnTop.video > 0 && btnTop.photo === 0 && btnTop.interview > 0) ||
                                  (btnTop.video > 0 && btnTop.photo > 0 && btnTop.interview === 0)
                                ? 2
                                : (btnTop.video > 0 && btnTop.photo === 0 && btnTop.interview === 0) ||
                                  (btnTop.video === 0 && btnTop.photo > 0 && btnTop.interview === 0) ||
                                  (btnTop.video === 0 && btnTop.photo === 0 && btnTop.interview > 0)
                                ? 1
                                : 0
                            )}
                          />
                        )}
                      </Tabs>
                    </Grid>

                    <Grid item xs={12}>
                      {btnTop.video > 0 && (
                        <TabPanel value={tab} index={0}>
                          <Grid
                            container
                            direction="row"
                            justifyContent="space-evenly"
                            alignItems="flex-start"
                            spacing={2}
                          >
                            {mediaMarket &&
                              mediaMarket.items.map((item: any, index: number) => {
                                if (item.type === 'VIDEO') {
                                  return (
                                    <Grid key={`${item.id}`} item>
                                      <VoteItem item={item} className={classes} />
                                    </Grid>
                                  )
                                } else return <></>
                              })}
                          </Grid>
                        </TabPanel>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      {btnTop.photo > 0 && (
                        <TabPanel value={tab} index={btnTop.video > 0 ? 1 : 0}>
                          <Grid
                            container
                            direction="row"
                            justifyContent="space-evenly"
                            alignItems="flex-end"
                            spacing={2}
                          >
                            {mediaMarket &&
                              photoMarket &&
                              photoMarket.map((item: any, index: number) => {
                                if (item.type === 'PHOTO') {
                                  return (
                                    <Grid key={`${item.id}`} item>
                                      <VoteItem
                                        item={item}
                                        indexPhoto={index}
                                        listPhoto={photoMarket}
                                        className={classes}
                                      />
                                    </Grid>
                                  )
                                } else return <></>
                              })}
                          </Grid>
                        </TabPanel>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      {btnTop.interview > 0 && (
                        <TabPanel
                          value={tab}
                          index={
                            btnTop.video > 0 && btnTop.photo > 0
                              ? 2
                              : btnTop.video === 0 && btnTop.photo > 0
                              ? 1
                              : btnTop.video > 0 && btnTop.photo === 0
                              ? 1
                              : 0
                          }
                        >
                          <Grid
                            container
                            direction="row"
                            justifyContent="space-evenly"
                            alignItems="flex-start"
                            spacing={2}
                          >
                            {mediaMarket &&
                              mediaMarket.items.map((item: any, index: number) => {
                                if (item.type === 'INTERVIEW') {
                                  return (
                                    <Grid key={`${item.id}`} item>
                                      <VoteItem item={item} className={classes} />
                                    </Grid>
                                  )
                                } else return <></>
                              })}
                          </Grid>
                        </TabPanel>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      {btnTop.reports > 0 && (
                        <TabPanel
                          value={tab}
                          index={
                            btnTop.video > 0 && btnTop.photo > 0 && btnTop.interview > 0
                              ? 3
                              : (btnTop.video === 0 && btnTop.photo > 0 && btnTop.interview > 0) ||
                                (btnTop.video > 0 && btnTop.photo === 0 && btnTop.interview > 0) ||
                                (btnTop.video > 0 && btnTop.photo > 0 && btnTop.interview === 0)
                              ? 2
                              : (btnTop.video > 0 && btnTop.photo === 0 && btnTop.interview === 0) ||
                                (btnTop.video === 0 && btnTop.photo > 0 && btnTop.interview === 0) ||
                                (btnTop.video === 0 && btnTop.photo === 0 && btnTop.interview > 0)
                              ? 1
                              : 0
                          }
                        >
                          <Grid
                            container
                            direction="row"
                            justifyContent="space-evenly"
                            alignItems="flex-end"
                            spacing={2}
                          >
                            {mediaMarket &&
                              photoReportsMarket &&
                              photoReportsMarket.map((item: any, index: number) => {
                                if (item.type === 'REPORTS') {
                                  return (
                                    <Grid key={`${item.id}`} item>
                                      <VoteItem
                                        item={item}
                                        indexPhoto={index}
                                        listPhoto={photoReportsMarket}
                                        className={classes}
                                      />
                                    </Grid>
                                  )
                                } else return <></>
                              })}
                          </Grid>
                        </TabPanel>
                      )}
                    </Grid>
                  </Grid>
                  {((tab === 0 && btnTop.video >= 6) ||
                    (tab === 1 && btnTop.photo >= 6) ||
                    (tab === 2 && btnTop.interview >= 6) ||
                    (tab === 3 && btnTop.reports >= 6)) && (
                    <Box mb={sm ? 2 : 3}>
                      <Grid container justifyContent="center">
                        <Grid item>
                          <IconButton color="primary" onClick={onScrollTop}>
                            <img src={img.upButton} alt="" className={classes.iconTop} />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </>
              ) : (
                <Grid container wrap="nowrap" spacing={2} className={classes.textBox}>
                  <Grid item>
                    <Box>
                      <AccessTimeIcon sx={{ fontSize: { xs: 34, sm: 40 } }} />
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box className={classes.text}>
                      Здесь пишется история КУБКА 2023 твоего маркета: заливай свои фото, видео и репортажи!
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Container>
            <img src={imgs.footerMedia} alt="" className={classes.mediaBottom} />
          </>
        ) : (
          <Grid container justifyContent="center" alignItems="center" height="50vh">
            <Grid item>
              <Loader />
            </Grid>
          </Grid>
        )}
      </Box>
    </Layout>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  page: {
    width: '100%',
    minHeight: 'calc(100vh - 240px)',
    padding: '50px 0 0',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: '#131313',
    '& .MuiTab-root': {
      padding: '8px 10px',
      minWidth: 140,
      fontSize: 14,
      borderRadius: 2,
      backgroundColor: 'transparent!important',
      color: '#6C6C6C!important',
      "&[aria-selected^='true']": {
        backgroundColor: `${palette.secondary.main}!important`,
      },
      [down('sm')]: {
        padding: '8px 10px',
        minWidth: 90,
        fontSize: 11,
      },
    },
    [down('md')]: {
      minHeight: 'calc(100vh - 280px)',
    },
    [down('sm')]: {
      padding: '40px 0 0',
      minHeight: 'calc(100vh - 200px)',
    },
  },
  container: {
    paddingBottom: '70px!important',
    [down('md')]: {
      padding: '0 10px 50px!important',
    },
  },
  title: {
    fontSize: 48,
    fontWeight: 700,
    color: palette.text.secondary,
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: '0.3s',
    '&:hover': {
      color: palette.text.primary,
    },
    [down('lg')]: {
      fontSize: 44,
    },
    [down('md')]: {
      fontSize: 42,
    },
    [down('sm')]: {
      textAlign: 'center',
      fontSize: 32,
      marginLeft: -30,
      maxWidth: 350,
    },
  },
  subTitle: {
    fontSize: 28,
    fontWeight: 700,
    color: palette.text.primary,
    textTransform: 'uppercase',
    margin: '30px 0 40px',
    [down('lg')]: {
      fontSize: 26,
    },
    [down('md')]: {
      fontSize: 24,
      margin: '25px 0 30px',
    },
    [down('sm')]: {
      fontSize: 20,
      textAlign: 'center',
      margin: '20px 0 30px',
    },
  },
  voteItemZoomBg: {
    position: 'relative',
    background: 'linear-gradient(#7D0A13, #080102) 0 0 no-repeat',
  },
  voteItemZoom: {
    width: 380,
    // height: 220,
    borderRadius: 6,
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      '& #play-container': {
        transform: 'scale(1.03)',
      },
      '& #play-btn': {
        transform: 'scale(1.03)',
      },
    },
    [down('md')]: {
      width: 280,
      // height: 170,
    },
  },
  voteItemZoomInterview: {
    width: 280,
    height: 170,
    borderRadius: 6,
    cursor: 'pointer',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      '& #play-container': {
        transform: 'scale(1.03)',
      },
      '& #play-btn': {
        transform: 'scale(1.03)',
      },
    },
  },
  voteItemVideo: {
    width: 380,
    height: 220,
    display: 'flex',
    borderRadius: 6,
    transition: '0.3s',
    alignItems: 'center',
    backgroundSize: '200px 103px',
    justifyContent: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundImage: `url(${img.proKubok})`,
    [down('md')]: {
      width: 280,
      height: 170,
    },
  },
  voteItemPlayBox: {
    width: 380,
    height: 220,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [down('md')]: {
      width: 280,
      height: 170,
    },
  },
  voteItemInterviewVideo: {
    width: 280,
    height: 170,
    display: 'flex',
    borderRadius: 6,
    transition: '0.3s',
    alignItems: 'center',
    backgroundSize: '200px 103px',
    justifyContent: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundImage: `url(${img.proKubok})`,
  },
  voteItemInterviewPlayBox: {
    width: 280,
    height: 170,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  voteItemInterviewPlay: {
    width: 55,
    height: 55,
    borderRadius: 30,
    display: 'flex',
    transition: '0.3s',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(108, 108, 108, 0.8)',
    backdropFilter: 'blur(10px)',
    '& svg': {
      fill: '#ffffff!important',
      fontSize: '35px!important',
    },
  },
  voteItemPlay: {
    width: 55,
    height: 55,
    borderRadius: 30,
    display: 'flex',
    transition: '0.3s',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(108, 108, 108, 0.8)',
    backdropFilter: 'blur(10px)',
    '& svg': {
      fill: '#ffffff!important',
      fontSize: '35px!important',
    },
  },
  voteItemPlayModal: {
    width: 70,
    height: 70,
    borderRadius: '50%',
    display: 'flex',
    transition: '0.2s',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(108, 108, 108, 0.8)',
    backdropFilter: 'blur(10px)',
    '& svg': {
      fill: '#ffffff!important',
      fontSize: '40px!important',
      [down('sm')]: {
        fontSize: '35px!important',
      },
    },
    [down('sm')]: {
      width: 55,
      height: 55,
    },
  },
  voteItemPhoto: {
    width: 380,
    minHeight: 220,
    display: 'flex',
    borderRadius: 6,
    transition: '0.3s',
    alignItems: 'center',
    justifyContent: 'center',
    [down('md')]: {
      width: 280,
      minHeight: 170,
    },
  },
  voteItemPhotoInterview: {
    width: 280,
    // minHeight: 170,
    display: 'flex',
    borderRadius: 6,
    transition: '0.3s',
    alignItems: 'center',
    justifyContent: 'center',
  },
  like: {
    fontSize: '28px!important',
    [down('sm')]: {
      fontSize: '25px!important',
    },
  },
  likeInterview: {
    fontSize: '25px!important',
  },
  numLike: {
    fontSize: 16,
    fontWeight: 500,
    [down('sm')]: {
      fontSize: 15,
    },
  },
  voteItemTitle: {
    width: 264,
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 20,
    padding: '0 8px',
    textTransform: 'uppercase',
    [down('sm')]: {
      fontSize: 15,
    },
  },
  voteItemText: {
    width: 364,
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 20,
    padding: '0 8px',
    [down('md')]: {
      width: 264,
    },
    [down('sm')]: {
      fontSize: 15,
      marginBottom: 0,
    },
  },
  voteItemTextSmall: {
    fontSize: '14px!important',
    width: '264px!important',
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    [down('sm')]: {
      fontSize: '13px!important',
    },
  },
  newsVideoBox: {
    maxWidth: 600,
    width: '100%',
    margin: '50px auto 30px',
    [down('sm')]: {
      maxWidth: 400,
    },
  },
  newsVideoBgImg: {
    maxWidth: 600,
    width: '100%',
    overflow: 'hidden',
    '& video': {
      borderRadius: 6,
    },
    [down('sm')]: {
      maxWidth: 400,
    },
  },
  newsVideoText: {
    fontSize: 18,
    width: '100%',
    maxWidth: 600,
    fontWeight: 500,
    margin: '0 auto',
    [down('sm')]: {
      fontSize: 16,
      maxWidth: 400,
    },
  },
  newsBox: {
    width: '100%',
  },
  imgBoxModal: {
    width: '100%',
    height: 800,
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: 6,
    [down('sm')]: {
      height: 400,
    },
  },
  imgModal: {
    width: '100%',
    borderRadius: 6,
  },
  titleModal: {
    fontSize: 20,
    fontWeight: 700,
    textAlign: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    lineHeight: 1.4,
    textTransform: 'uppercase',
    margin: '20px 0',
    [down('sm')]: {
      fontSize: 18,
      paddingLeft: 10,
      paddingRight: 10,
      margin: '15px 0',
    },
  },
  textModal: {
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    lineHeight: 1.4,
    [down('sm')]: {
      fontSize: 14,
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
  textPhotoModal: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.4,
    marginTop: 30,
    [down('sm')]: {
      fontSize: 15,
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
  voteItemFurther: {
    float: 'right',
  },
  link: {
    fontSize: 12,
    float: 'right',
    fontWeight: 700,
    transition: '0.3s',
    cursor: 'pointer',
    textDecoration: 'none!important',
    '-webkit-tap-highlight-color': 'transparent',
    color: '#6C6C6C!important',
    '&:hover': {
      color: 'rgb(255, 255, 255, 0.6)!important',
    },
    [down('lg')]: {
      margin: '15px 0',
      fontSize: 12,
    },
    [down('sm')]: {
      margin: '15px 0',
      fontSize: 11,
    },
  },
  mediaBottom: {
    position: 'absolute',
    bottom: 10,
    width: '100%',
    minWidth: 1100,
  },
  iconTop: {
    width: 80,
    height: 80,
    [down('md')]: {
      width: 65,
      height: 65,
    },
    [down('sm')]: {
      width: 55,
      height: 55,
    },
  },
  btnArrow: {
    width: 40,
    height: 40,
    border: `2px solid ${palette.secondary.main}!important`,
    transition: '0.2s!important',
    '& #icon-arrow': {
      fontSize: '28px!important',
      transition: '0.2s!important',
      color: `${palette.primary.main}!important`,
    },
    '&:hover': {
      border: '2px solid #6C6C6C!important',
      '& #icon-arrow': {
        color: '#6C6C6C!important',
      },
    },
    [down('md')]: {
      width: 38,
      height: 38,
      '& #icon-arrow': {
        fontSize: '25px!important',
      },
    },
    [down('sm')]: {
      width: 35,
      height: 35,
      '& #icon-arrow': {
        fontSize: '20px!important',
      },
    },
  },
  textBox: {
    paddingTop: '30px',
    '& svg': {
      fill: '#6C6C6C!important',
    },
  },
  text: {
    fontSize: 18,
    maxWidth: 550,
    color: '#6C6C6C!important',
    height: 'calc(100vh - 560px)',
    [down('md')]: {
      height: 'calc(100vh - 500px)',
      fontSize: 17,
    },
    [down('sm')]: {
      height: 'calc(100vh - 420px)',
      fontSize: 16,
    },
  },
  boxSlider: {
    width: '100%',
    margin: '0 auto',
    '& .slick-list': {
      width: '90%',
      position: 'relative',
      left: '5%',
    },
    '& .slick-slide': {},
    '& .slick-next:before, .slick-prev:before': {
      content: 'none',
      width: '60px!important',
      height: '60px!important',
      [down('sm')]: {
        width: '50px!important',
        height: '50px!important',
      },
    },
    '& .slick-next': {
      width: '60px!important',
      height: '60px!important',
      right: -15,
      [down('sm')]: {
        width: '50px!important',
        height: '50px!important',
      },
    },
    '& .slick-prev': {
      left: -15,
      width: '60px!important',
      height: '60px!important',
      [down('sm')]: {
        width: '50px!important',
        height: '50px!important',
      },
    },
  },
  slide: {
    display: 'flex!important',
    alignItems: 'center',
    minHeight: 500,
    [down('sm')]: {
      minHeight: 400,
    },
  },
  willChanges: {
    imageRendering: 'auto',
    willChange: 'transform',
    transform: 'translate3d(0, 0, 0)',
  },
}))
